import { ToolPageShell } from '@/shared/seo'
import { VodyanojZnakPdfForm } from './VodyanojZnakPdfForm'

export function VodyanojZnakPdfPage() {
  return (
    <ToolPageShell utilityKey="watermark-pdf">
      <VodyanojZnakPdfForm />
    </ToolPageShell>
  )
}
